module.exports = __webpack_public_path__ + "img/wildscapes.83eb0e32.jpg";